class UploadResumesProcessedCandidatesModalController {
    /*@ngInject*/
    constructor() {
    }
    $onInit() {
        this.gettingCountsFlag = false;
        this.reviewHtmlText = `<p>Resumes processed heading</p>`;
        this.candidatesCount = this.resolve.candidatesCount;
        this.jobId = this.resolve.jobId;
        this.candidateId = this.resolve.candidateId;
        this.notificationId = this.resolve.notificationId;
        this.headingTitle = this.resolve.headingTitle;
    }
    closeModal() {
        this.modalInstance.close('cancel');
    }
    dismissModal() {
        this.modalInstance.dismiss('dismiss');
    }
}
import * as TEMPLATE from 'raw-loader!./upload-resumes-processed-candidates-modal.html';
export const UploadResumesProcessedCandidatesModalComponent = {
    selector: 'uploadResumesProcessedCandidatesModal',
    component: {
        bindings: {
            modalInstance: '<',
            resolve: '<'
        },
        template: TEMPLATE.default,
        controller: UploadResumesProcessedCandidatesModalController
    }
};
//# sourceMappingURL=upload-resumes-processed-candidates-modal.component.js.map